//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant'
import { IndexImgList } from '@/api/index'
export default {
  name: 'HomePage',
  components: {

  },
  data () {
    return {
      baseUrl: this.global.baseUrl,
      imgWidth: 150,
      imgHeight: 200,
      backImg: '',
      divStyle:{
        backgroundImage: '',
      },
      imgInfo: {}
    }
  },
  created() {
    this.init();
  },
  methods: {
    init(){
      IndexImgList().then(resp => {
        this.imgInfo = resp.data
        this.backImg = this.imgInfo.index
        this.divStyle.backgroundImage = 'url(' + this.baseUrl + this.backImg + ')'
      }).catch(error => {
        Toast(error.message)
      })
    },
    showInfo (item) {
      let result = ''
      let type = "",title = ''
      if (item === 1) {
        result = '/acupoint'
      } else if (item === 2) {
        result = '/category'
        type = '100101'
        title = '艾灸'
      } else if (item == 3) {
        result = '/category'
        type = '100102'
        title = '刮痧'
      } else {
        result = "/category"
        type = '100103'
        title = '拔罐'
      }
      this.$router.push({
        path: result,
        query: {
          type: type,
          title: title
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePage.vue